
import {
  saveAddress, addressList, deleteAdress, pageVisit, getDataAddress
} from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import NavMenu from '@/common/navmenu.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { validateTelPhone } from '@/tools/regexp';
import addData from '../../assets/json/address.json';
import { readCookie } from '../../tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu
  }
})
export default class extends Vue {
  dialogStatus: String = 'create'

  textMap: any = {
    update: '编辑地址',
    create: '新增地址'
  }

   isEdit: boolean = false

  // 有无数据
  isNodata: boolean = false

  ruleForm: any = {
    realName: '',
    cityId: '',
    cityName: '',
    areaId: '',
    areaName: '',
    address: '',
    telephone: '',
    defaultAddress: 0,
    provinceId: '',
    provinceName: '',
    addressTemp: ''
  }

  options: any[] = []

  cityOptions: any[] = []

  areaOptions: any[] = []

  menus: any[] = [
    {
      name: '个人账户',
      isOpen: true,
      child: [
        {
          id: 1,
          name: '个人中心'
        },
        {
          id: 2,
          name: '个人信息'
        },
        {
          id: 3,
          name: '安全设置'
        },
        {
          id: 4,
          name: '地址管理'
        }
      ]
    },
    {
      name: '交易管理',
      isOpen: true,
      child: [
        {
          id: 5,
          name: '我的订单'
        },
        {
          id: 6,
          name: '售后服务'
        }
      ]
    },
    {
      name: '客户服务',
      isOpen: true,
      child: [
        {
          id: 7,
          name: '发票资质'
        }
      ]
    }
  ]

  value: any[] = []

  showDialogBack: boolean = false

  infoList: any[] = [] // 价格列表

  ordernumber: any = {}

  province: any[] = []

  sheng: String = ''

  qu: String = ''

  E: String = ''

  shi1: any = []

  qu1: any = []

  city: any = []

  block: any = []

  addressList: any = []

  currentIndex: number = 4

  listQuery: any = {
    pageNo: 1,
    pageSize: 20
  }

  rules: object = {
    realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
    telephone: [
      { required: true, validator: validateTelPhone, trigger: 'blur' }
    ],
    areaId: [{ required: true, message: '请选择地址' }],
    addressTemp: [
      { required: true, message: '请输入详细地址', trigger: 'blur' }
    ]
  }

  @Mutation('address/SELECTADDRESS') SELECTADDRESS!: Function

  created() {
    this.getCityData();
    this.addressLists();
    this.pageVisit();
  }

  private async addressLists() {
    const res: any = await addressList(this.listQuery);
    this.addressList = res.data.data;
    this.isNodata = res.data.data.length === 0;
  }

  private async changeChild(index: number) {
    this.currentIndex = index;
  }

  openAdd() {
    this.value = [];
    this.dialogStatus = 'create';
    this.showDialogBack = true;
    this.$nextTick(() => {
      const form = this.$refs.ruleForm as any;
      form.resetFields();
      this.ruleForm = {
        realName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        address: '',
        telephone: '',
        defaultAddress: 0,
        provinceId: '',
        provinceName: '',
        addressTemp: ''
      };
    });
  }

  openEdit(item: any) {
    this.ruleForm = {
      id: item.id,
      realName: item.realName,
      cityId: item.cityCode,
      cityName: item.cityName,
      areaId: item.areaCode,
      areaName: item.areaName,
      address: item.address,
      telephone: item.telephone,
      defaultAddress: item.defaultAddress,
      provinceId: item.provinceCode,
      provinceName: item.provinceName,
      addressTemp: item.address.split(
        `${item.provinceName}${item.cityName}${item.areaName}`
      )[1]
    };
    this.cityOptions = this.options.filter(
      (e) => e.value === this.ruleForm.provinceId
    )[0].children;
    this.areaOptions = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children;
    this.dialogStatus = 'upadate';
    this.showDialogBack = true;
    this.pageVisit();
  }

  // 选择省份
  chooseProvince(id: number) {
    this.ruleForm.provinceName = this.options.filter(
      (e) => e.value === id
    )[0].label;
    this.ruleForm.cityId = this.options.filter(
      (e) => e.value === id
    )[0].children[0].value;
    this.ruleForm.cityName = this.options.filter(
      (e) => e.value === id
    )[0].children[0].label;
    this.cityOptions = this.options.filter((e) => e.value === id)[0].children;
    this.areaOptions = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children;
    this.ruleForm.areaId = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children[0].value;
    this.ruleForm.areaName = this.cityOptions.filter(
      (e) => e.value === this.ruleForm.cityId
    )[0].children[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  // 选择市
  chooseCity(id: number) {
    this.ruleForm.cityName = this.cityOptions.filter(
      (e) => e.value === id
    )[0].label;
    this.areaOptions = this.cityOptions.filter((e) => e.value === id)[0].children;
    this.ruleForm.areaId = this.cityOptions.filter(
      (e) => e.value === id
    )[0].children[0].value;
    this.ruleForm.areaName = this.cityOptions.filter(
      (e) => e.value === id
    )[0].children[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  // 选择区
  chooseArea(id: number) {
    this.ruleForm.areaName = this.areaOptions.filter(
      (e) => e.value === id
    )[0].label;
    this.$nextTick(() => {
      (this as any).$refs.ruleForm.clearValidate('areaId');
    });
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: this.isEdit ? 12 : 11,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }

  // 删除地址信息
  private async openDelete(id: number) {
    this.$msgbox({
      title: '消息',
      message: '删除后将无法恢复，是否继续？',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          const res: any = await deleteAdress({ id });
          if (res.data.code === 100) {
            done();
            this.$message.success('删除成功');
            this.addressLists();
          } else {
            done();
            this.$message.error(res.data.message);
          }
        } else {
          done();
        }
      }
    });
  }

  // 设为默认地址
  private async updateDefaultData(item: any) {
    const anchor = readCookie('anchor');
    if (item.defaultAddress !== 1) {
      this.ruleForm = {
        id: item.id,
        realName: item.realName,
        cityId: item.cityCode,
        cityName: item.cityName,
        areaId: item.areaCode,
        areaName: item.areaName,
        address: item.address,
        telephone: item.telephone,
        defaultAddress: 1,
        provinceId: item.provinceCode,
        provinceName: item.provinceName,
        addressTemp: item.address.split(
          `${item.provinceName}${item.cityName}${item.areaName}`
        )[1]
      };
      const res: any = await saveAddress(this.ruleForm);
      if (res.data.code === 100) {
        this.showDialogBack = false;
        getDataAddress({
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          eventNo: '3.1.2.0.0.0.1',
          provinceName: item.provinceCode,
          cityName: item.cityCode,
          country: item.cityCode,
          companyId: 1
        });
        this.addressLists();
        this.$message.success('修改成功');
      } else {
        this.$message.error(res.data.message);
      }
    }
  }

  // 修改地址
  private async updateData() {
    const anchor = readCookie('anchor');
    const form = this.$refs.ruleForm as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isEdit = true;
        this.ruleForm.address = `${this.ruleForm.provinceName}${this.ruleForm.cityName}${this.ruleForm.areaName}${this.ruleForm.addressTemp}`;
        const res: any = await saveAddress(this.ruleForm);
        if (res.data.code === 100) {
          getDataAddress({
            equip: anchor ? anchor.equip : 4,
            version: anchor ? anchor.version : '',
            src: anchor ? (anchor.src ? anchor.src : 2) : 4,
            model: anchor ? anchor.model : '',
            equipVersion: anchor ? anchor.equipVersion : '',
            equipMeid: anchor ? anchor.equipMeid : '',
            eventNo: '3.1.2.0.0.0.2',
            provinceName: this.ruleForm.provinceId,
            cityName: this.ruleForm.cityId,
            country: this.ruleForm.areaId,
            companyId: 1
          });
          this.showDialogBack = false;
          this.addressLists();
          this.pageVisit();
          this.$message.success('修改成功');
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }

  private async createData() {
    const anchor = readCookie('anchor');
    const form = this.$refs.ruleForm as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.ruleForm.address = this.ruleForm.provinceName
          + this.ruleForm.cityName
          + this.ruleForm.areaName
          + this.ruleForm.addressTemp;
        if (this.isNodata) {
          this.ruleForm.defaultAddress = 1;
        }
        const res: any = await saveAddress(this.ruleForm);
        if (res.data.code === 100) {
          getDataAddress({
            equip: anchor ? anchor.equip : 4,
            version: anchor ? anchor.version : '',
            src: anchor ? (anchor.src ? anchor.src : 2) : 4,
            model: anchor ? anchor.model : '',
            equipVersion: anchor ? anchor.equipVersion : '',
            equipMeid: anchor ? anchor.equipMeid : '',
            eventNo: '3.1.2.0.0.0.2',
            provinceName: this.ruleForm.provinceId,
            cityName: this.ruleForm.cityId,
            country: this.ruleForm.areaId,
            companyId: 1
          });
          this.showDialogBack = false;
          this.addressLists();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }

  private async getCityData() {
    this.options = addData.data;
  }

  // 确认订单选择地址列表
  //  选择收货地址
  private selectAddress(item: any) {
    const { id } = this.$route.query;
    if (id === '0') {
      this.SELECTADDRESS([
        {
          id: item.id,
          address: item.address,
          realName: item.realName,
          telephone: item.telephone,
          defaultAddress: item.defaultAddress,
          select: true
        }
      ]);
      this.$router.back();
    }
  }
}
